/**
 * @generated SignedSource<<34f94f38cd5428fe84cf74c2e120eb0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type DeletionReason = "AUTO" | "MANUAL";
import { FragmentRefs } from "relay-runtime";
export type utils_AddedOrAvailableUntil_meetingRecording$data = {
  readonly meetingCallEnd: string | null;
  readonly meetingRecordingVideoDeletionReason: DeletionReason | null;
  readonly recordingAndTranscriptWillBeDeleted: boolean;
  readonly recordingDataAutoDeletionDate: string | null;
  readonly transcriptDeletionReason: DeletionReason | null;
  readonly " $fragmentType": "utils_AddedOrAvailableUntil_meetingRecording";
};
export type utils_AddedOrAvailableUntil_meetingRecording$key = {
  readonly " $data"?: utils_AddedOrAvailableUntil_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"utils_AddedOrAvailableUntil_meetingRecording">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "utils_AddedOrAvailableUntil_meetingRecording",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingCallEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recordingAndTranscriptWillBeDeleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transcriptDeletionReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordingVideoDeletionReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recordingDataAutoDeletionDate",
      "storageKey": null
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};

(node as any).hash = "a06b453f5edab41d00069c10d02bd98e";

export default node;
